import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@cyberint/stateful-ui/i18n';
import * as S from './styled';

export const EmptyStateMessage = ({ fontSize = 14, margin = '40px 0 0 0' }) => (
  <S.Message $fontSize={fontSize} $margin={margin}>
    {t('common.no_items_to_show')}
  </S.Message>
);

EmptyStateMessage.propTypes = {
  fontSize: PropTypes.number,
  margin: PropTypes.string
};
